

















import { Vue, Component, Prop } from "vue-property-decorator";
import VueDatepicker from "vuejs-datepicker";
import { ja, en } from "vuejs-datepicker/dist/locale";
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

@Component({
  components: { VueDatepicker, VueTimepicker }
})
export default class DateTimePicker extends Vue {
  @Prop({ type: Date, required: false, default: new Date() }) value!: Date;

  get locale(): any {
    return ja;
  }

  get format(): string {
    return "yyyy年MM月dd日";
  }

  get hours(): number {
    return this.value.getHours();
  }

  get minutes(): number {
    return Math.floor(this.value.getMinutes() / 15) * 15;
  }

  get time(): { HH: string; mm: string } {
    const HH = this.hours.toString().padStart(2, "0");
    const mm = this.minutes.toString().padStart(2, "0");
    return { HH, mm };
  }

  setDate(input: Date) {
    const date = new Date(
      input.getFullYear(),
      input.getMonth(),
      input.getDate(),
      this.hours,
      this.minutes
    );
    this.$emit("input", date);
  }

  setTime(obj: { HH: string; mm: string }) {
    const date = new Date(
      this.value.getFullYear(),
      this.value.getMonth(),
      this.value.getDate(),
      Number(obj.HH),
      Number(obj.mm)
    );
    this.$emit("input", date);
  }
}
